angular.
module("dx.webapp.saml").
factory("DxSAMLIdentityProvider", function SAMLIdentityProviderFactoryService(
	dxDateUtils
) {
	"use strict";

	return function SAMLIdentityProvider(initial) {
		if (!(this instanceof SAMLIdentityProvider)) {
			throw new Error("Constructor must be called with 'new'.");
		}

		angular.extend(this, {
			entityId: "",
			organizationNameEN: "",
			organizationNameSV: "",
			validUntil: null,
			identityProviderXml: "",
			idpSrc: "",
			enabled: false,
			organizationId: 0,
			created: null,
			modified: null,
			deleted: false,
		});

		if (initial) {
			angular.extend(this, initial);
			this.validUntil = dxDateUtils.getDateIfValid(this.validUntil);
			this.created = dxDateUtils.getDateIfValid(this.created);
			this.modified = dxDateUtils.getDateIfValid(this.modified);
		}
	};
});
